(function () {
(function($) {
    const behavior = "polyu_theme.home-video-block";
    Drupal.behaviors[behavior] = {
        attach: (context, settings)=>{}
    };
    $(function() {
        $("#homeVideoCarousel").on("loadeddata", function() {
            polyu_handle_bullet_init();
        });
        $("#homeVideoCarousel").bind("timeupdate", function() {
            polyu_handle_video_update();
        });
    });
    function polyu_handle_bullet_init() {
        const video = $("#homeVideoCarousel")[0];
        const bulletItems = $(".bullet-item");
        const duration = video.duration;
        // Generate bullet points dynamically based on the video duration and data-timestamp attributes
        bulletItems.each(function() {
            const bulletItem = $(this);
            const timestamp = bulletItem.data("timestamp");
            const distance = convertTimestampToSeconds(timestamp) / duration * 100;
            bulletItem.css("left", distance + "%");
            bulletItem.on("click", function() {
                video.currentTime = convertTimestampToSeconds(timestamp);
                handleCaption(timestamp);
                handleBulletActive(bulletItem);
            });
            bulletItem.hover(function() {
                handleTooltip(bulletItem);
            });
        });
    }
    function polyu_handle_video_update() {
        const video = document.getElementById("homeVideoCarousel");
        const seekBar = $(".bullet-seek-bar-over");
        const bulletItems = $(".bullet-item");
        const totalDuration = video.duration;
        var currentTime = video.currentTime;
        seekBar.attr("data-max", totalDuration);
        // Update the position of the seek bar as video plays
        var currentDistance = currentTime / totalDuration * 100;
        seekBar.css("width", currentDistance + "%");
        bulletItems.each(function() {
            const bulletItem = $(this);
            const timestamp = bulletItem.data("timestamp");
            const distance = convertTimestampToSeconds(timestamp) / totalDuration * 100;
            if (currentDistance >= distance) {
                bulletItem.addClass("activate");
                handleCaption(timestamp);
                handleBulletActive(bulletItem);
            } else {
                bulletItem.removeClass("activate");
                bulletItem.removeClass("active");
            }
        });
    // for (var i = 0; i < bullets.length; i++) {
    //   if (video.currentTime >= bullets[i].getAttribute("data-timestamp")) {
    //     bullets[i].classList.add("active");
    //     currentTimestamp = bullets[i].getAttribute("data-timestamp");
    //   } else {
    //     bullets[i].classList.remove("active");
    //     break;
    //   }
    // }
    }
    // helper function to convert a timestamp to seconds
    function convertTimestampToSeconds(timestamp) {
        var parts = timestamp.split(":");
        var seconds = parseInt(parts[parts.length - 1]);
        if (parts.length > 1) {
            var minutes = parseInt(parts[parts.length - 2]);
            seconds += minutes * 60;
        }
        return seconds;
    }
    // Helper functions
    function handleCaption(timestamp) {
        const caption = $(".caption");
        const currentCaption = $(`.caption-item[data-timestamp="${timestamp}"]`);
        const activeCaption = $(".caption-item.active");
        if (activeCaption.length > 0 && !activeCaption.is(currentCaption)) activeCaption.removeClass("active");
        if (currentCaption.length > 0) currentCaption.addClass("active");
        else caption.empty();
    }
    function handleBulletActive(bulletItem) {
        const activeBullet = $(".bullet-item.active");
        if (activeBullet.length > 0 && !activeBullet.is(bulletItem)) activeBullet.removeClass("active");
        bulletItem.addClass("active");
    }
    function handleTooltip(bulletItem) {
        const tooltip = bulletItem.find(".bullet-tooltip");
        const tooltipText = tooltip.text();
        const caption = $(".caption");
        tooltip.addClass("show-tooltip");
        // Position tooltip based on the position of the bullet item
        const tooltipLeft = bulletItem.position().left + bulletItem.outerWidth() / 2 - tooltip.outerWidth() / 2;
    //tooltip.css('left', `${tooltipLeft}px`);
    }
})(jQuery);

})();
//# sourceMappingURL=paragraph--home-video-block.js.map
